import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";

const ActiveUserInfo = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [showTypes, setShowTypes] = useState(false);
  const onSubmit = (value) => {
    if (!activeUserDetail) {
      return toast.error("User details not found or Your KYC is incomplete. Thank You!");
    }
    if (value.address_type.length > 1) {
      localStorage.setItem(
        "AddressRequestType",
        "Permanent and Communication Address Modification"
      );
      setStep("Digilocker");
    } else if (value.address_type[0] === "Permanent Address Modification") {
      localStorage.setItem("AddressRequestType", value.address_type[0]);
      setStep("Digilocker");
    } else {
      localStorage.setItem("AddressRequestType", value.address_type[0]);
      setStep("CheckPrevRequest");
    }
  };
  const getCommunicationAddress = (address = []) => {
    let res =
      (address.length > 0 && address.filter((item) => item.is_primary === 1)[0]) || {};
    return res;
  };
  return (
    <div>
      <Title title="Address Details" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          {activeUserDetail && (
            <div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Full Name</h6>
                  <div className="col-sm">{activeUserDetail.full_name}</div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Mobile Number</h6>
                  <div className="col-sm">{activeUserDetail.phone?.slice(2)}</div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">Email Address</h6>
                  <div className="col-sm">{activeUserDetail.email}</div>
                </div>
              </div>
              <div className="row mt-1">
                <div className="row">
                  <h6 className="col-sm">PAN Number</h6>
                  <div className="col-sm">{activeUserDetail.poi?.[0]?.pan_number}</div>
                </div>
              </div>
              <div className="row mt-2">
                <h5 className="text-bold m-0">Permanent Address</h5>
                <div className="row my-1">
                  <div className="col-sm">Address</div>
                  <div className="col-sm">{activeUserDetail.address_line1}</div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">City</div>
                  <div className="col-sm">{activeUserDetail.city}</div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">State</div>
                  <div className="col-sm">{activeUserDetail.state}</div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">Pincode</div>
                  <div className="col-sm">{activeUserDetail.pincode}</div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">Country</div>
                  <div className="col-sm">{activeUserDetail.country}</div>
                </div>
              </div>
              <div className="row mt-2">
                <h5 className="text-bold m-0">Correspondence Address</h5>
                <div className="row my-1">
                  <div className="col-sm">Address</div>
                  <div className="col-sm">
                    {
                      getCommunicationAddress(activeUserDetail.communication_address)
                        .address_line1
                    }
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">City</div>
                  <div className="col-sm">
                    {getCommunicationAddress(activeUserDetail.communication_address).city}
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">State</div>
                  <div className="col-sm">
                    {
                      getCommunicationAddress(activeUserDetail.communication_address)
                        .state
                    }
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">Pincode</div>
                  <div className="col-sm">
                    {
                      getCommunicationAddress(activeUserDetail.communication_address)
                        .pincode
                    }
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-sm">Country</div>
                  <div className="col-sm">
                    {
                      getCommunicationAddress(activeUserDetail.communication_address)
                        .country
                    }
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="d-flex mt-4">
            <div className="ml-2">
              <Button
                title="Back"
                type="button"
                handleClick={() => setStep("ValidatePan")}
                loading={isLoading}
              />
            </div>
            <div className="mx-2">
              <Button
                title="Next"
                handleClick={() => setShowTypes((show) => !show)}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        backdrop="static"
        keyboard={false}
        show={showTypes}
        onHide={setShowTypes}
      >
        <Modal.Header>
          <Modal.Title>Address Modification Types</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            <Formik
              enableReinitialize={true}
              initialValues={{ address_type: [] }}
              validate={(values) => {
                const errors = {};
                if (values.address_type.length === 0) {
                  errors.address_type = "Address type is required";
                }
                return errors;
              }}
              onSubmit={onSubmit}
            >
              {({ isValid, dirty, isSubmitting, setFieldValue }) => (
                <Form>
                  <div className="row">
                    <div className="col-sm form-group">
                      <label className="mb-2">Please select an option</label>
                      {[
                        {
                          name: "Correspondence Address Modification",
                          value: "Communication Address Modification",
                        },
                        {
                          name: "Permanent Address Modification",
                          value: "Permanent Address Modification",
                        },
                      ].map((item) => {
                        return (
                          <div className="form-check my-1" key={item.name}>
                            <Field
                              name="address_type"
                              className="form-check-input"
                              type="checkbox"
                              value={item.value}
                            />
                            <label className="form-check-label">{item.name}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end form-group my-4">
                    <div className="mx-2">
                      <Button
                        type="button"
                        title="Close"
                        handleClick={() => setShowTypes((show) => !show)}
                      />
                    </div>
                    <div className="mx-2">
                      <Button
                        title="Submit"
                        disabled={!isValid || !dirty || isSubmitting}
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ActiveUserInfo;
